/* Sets CSS variable to get width of viewport with/without scrollbar */
export const setViewportWidth = () => {
  const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  if (window.visualViewport) {
    document.documentElement.style.setProperty('--viewportWidth', `${window.visualViewport.width}px`)
  } else {
    const sbw = !isMobileDevice ? window.innerWidth - document.body.clientWidth : 0
    document.documentElement.style.setProperty('--scrollbarWidth', `${sbw}px`)
  }
}

// recalculate on resize
window.addEventListener('resize', setViewportWidth, false)
// recalculate on dom load
window.addEventListener('DOMContentLoaded', setViewportWidth, false)
// recalculate on load (assets loaded as well)
window.addEventListener('load', setViewportWidth)

export const setColumnCount = (count) => {
  localStorage.setItem('columnCount', count)
  document.documentElement.style.setProperty('--columnCount', count)
}

export const getColumnCount = () => {
  const columnCount = localStorage.getItem('columnCount') ? localStorage.getItem('columnCount') : 3
  setColumnCount(columnCount)
  return parseInt(columnCount)
}
